import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {
  WbSunnyOutlined,
  CheckCircleOutlined,
  PersonOutlineOutlined,
  QueryStatsOutlined,
  CasesOutlined,
  DescriptionOutlined,
  ChatOutlined,
  AutorenewOutlined,
  CampaignOutlined,
  MarkChatUnreadOutlined,
} from 'views/icons';

import NavbarService from './NavbarService';

import {useLocation} from 'react-router-dom';
import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const NavbarServices = (props) => {
  const {
    account,
  } = props;

  const location = useLocation();
  const caregiverReadFlag = useFlag(FLAGS.CAREGIVER_READS_FROM_LOOM);
  const loomCaregiverOptions = caregiverReadFlag.isEnabled ? [{
    title: 'navbar.NavOptions.Caregiver.Options.LoomList',
    link: '/caregiver-loom',
  }] : [];
  const jobReadFlag = useFlag(FLAGS.JOB_READS_FROM_LOOM);
  const loomJobOptions = jobReadFlag.isEnabled ? [{
    title: 'navbar.NavOptions.Career.Options.LoomList',
    link: '/career/loom',
  }] : [];
  const clientReadFlag = useFlag(FLAGS.CLIENT_READS_FROM_LOOM);
  const loomClientOptions = clientReadFlag.isEnabled ? [{
    title: 'navbar.NavOptions.Client.Options.LoomList',
    link: '/client/loom',
  }] : [];
  const loomLeadOptions = clientReadFlag.isEnabled ? [{
    title: 'navbar.NavOptions.ClientLead.Options.LoomList',
    link: '/client_lead/loom',
  }] : [];
  const scheduleReadFlag = useFlag(FLAGS.SCHEDULE_READS_FROM_LOOM);
  const loomClientScheduleOptions = scheduleReadFlag.isEnabled ? [{
    title: 'navbar.NavOptions.Schedule.Options.LoomClient',
    link: '/schedule/client/loom',
  }] : [];
  const loomCaregiverScheduleOptions = scheduleReadFlag.isEnabled ? [{
    title: 'navbar.NavOptions.Schedule.Options.LoomCaregiver',
    link: '/schedule/caregiver/loom',
  }] : [];

  return (
    <Box
      sx={{
        mb: 1,
        ml: 1,
      }}
    >
      <Box>
        <NavbarService
          currentPath={location.pathname}
          options={[
            {
              title: 'navbar.NavOptions.MyDay',
              link: '/tasks/my-day',
              icon: <WbSunnyOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
              count: 'mytasks',
            },
            {
              title: 'navbar.NavOptions.AllTasks',
              link: '/tasks/all-tasks',
              icon: <CheckCircleOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
              count: 'alltasks',
            },
            {
              title: 'navbar.NavOptions.Inbox',
              link: '/inbox',
              icon: <MarkChatUnreadOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
          ]}
        />
      </Box>
      <Box>
        <NavbarService
          title={'navbar.NavHeaders.Records'}
          currentPath={location.pathname}
          options={[
            ...(account === 'care' ? [
              {
                title: 'navbar.NavOptions.ClientLead.Options.List',
                link: '/client_lead',
                icon: <PersonOutlineOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
              },
              ...loomLeadOptions,
            ] : []),
            ...(account === 'recruiter' ? [
              {
                title: 'navbar.NavOptions.Caregiver.Options.List',
                link: '/caregiver',
              },
              ...loomCaregiverOptions,
              {
                title: 'navbar.NavOptions.Career.Options.List',
                link: '/career',
              },
              ...loomJobOptions,
            ] : []),
            ...(account === 'ops' ? [
              {
                title: 'navbar.NavOptions.Client.Options.List',
                link: '/client',
              },
              ...loomClientOptions,
              {
                title: 'navbar.NavOptions.Caregiver.Options.List',
                link: '/caregiver',
              },
              ...loomCaregiverOptions,
              {
                title: 'navbar.NavOptions.Schedule.Options.Client',
                link: '/schedule/client',
              },
              ...loomClientScheduleOptions,
              {
                title: 'navbar.NavOptions.Schedule.Options.Caregiver',
                link: '/schedule/caregiver',
              },
              ...loomCaregiverScheduleOptions,
            ] : []),
          ]}
        />
        {
          account === 'care' &&
            <NavbarService
              title={'navbar.NavHeaders.Metrics'}
              currentPath={location.pathname}
              options={[
                {
                  title: 'navbar.NavOptions.Metrics.Options.LeadFunnel',
                  link: '/metrics/lead-funnel',
                  icon: <QueryStatsOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
                },
                {
                  title: 'navbar.NavOptions.Metrics.Options.ClientMetrics',
                  link: '/metrics/clients',
                  icon: <QueryStatsOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
                },
                {
                  title: 'navbar.NavOptions.Metrics.Options.AgentReportCard',
                  link: '/metrics/agent-report-card',
                  icon: <QueryStatsOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
                },
              ]}
            />
        }
        <NavbarService
          title={'navbar.NavHeaders.System'}
          currentPath={location.pathname}
          options={[
            {
              title: 'navbar.NavOptions.Playbooks',
              link: '/playbooks',
              icon: (
                <Box
                  component='img'
                  src='/icons/playbook.svg'
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                />
              ),
            },
            {
              title: 'navbar.NavOptions.Skills',
              link: '/skills',
              icon: (
                <Box
                  component='img'
                  src='/icons/skill.svg'
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                />
              ),
            },
            {
              title: 'navbar.NavOptions.Cases',
              link: '/cases',
              icon: <CasesOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.DomainGuides',
              link: '/domain-guides',
              icon: <DescriptionOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.Agent.Options.Chat',
              link: '/agent/chat',
              icon: <ChatOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.Agent.Options.Routines',
              link: '/agent/routines',
              icon: <AutorenewOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.BulkMessaging',
              link: '/bulk-messaging',
              icon: <CampaignOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
          ]}
        />
      </Box>
    </Box>
  );
};

NavbarServices.propTypes = {
  account: PropTypes.oneOf(['care', 'recruiter', 'ops']).isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarServices));
